
import React, {useState, useEffect, useCallback} from 'react';
import {Input, message, Button, Image, Modal, Space, Checkbox} from 'antd'
import {useParams, useNavigate} from 'react-router-dom'
import PicUploader, {FileUploader} from '../../components/Uploader'
import JobFairApi from '../../api/jobfair'
import LineModal from "./line.modal";
import SchoolModal from "./school.modal";
import {emptyValidate} from "../../util/validate";


export default function JobFairUpdate () {
    const navigate = useNavigate();
    const params = useParams();

    const [info, setInfo] = useState({})
    const [labelList, setLabelList] = useState([])

    useEffect(()=>{
        loadData();
    },[])

    const loadData = useCallback(()=>{
        JobFairApi.getDetail(params.id).then(resp=>{
            const data = resp.info;
            setInfo(data.info)
            setLabelList(data.labelList)
        })
    })

    const onInfoUpdate = useCallback((data={})=>{
        setInfo(Object.assign(info, data))
    })

    const onLabelListUpdate = useCallback((list={})=>{
        setLabelList(list)
    })

    const save = useCallback(()=>{

        let validateResult = emptyValidate(info.bannerPc, '请上传"宣传页主题-banner（PC端）"')
            || emptyValidate(info.bannerPc, '请上传"宣传页主题-banner（WAP端）"')
            || emptyValidate(info.processPc, '请上传"招聘会流程-PC端"')
            || emptyValidate(info.processWap, '请上传"招聘会流程-WAP端"')

          if (info.chargeShow) {
              validateResult = validateResult || emptyValidate(info.chargePc, '请上传"参会报名费用-PC端"')
              || emptyValidate(info.chargeWap, '请上传"参会报名费用-WAP端"')
          }

        if (info.reviewShow) {
            validateResult = validateResult || emptyValidate(info.video, '请上传"往期精彩回顾-宣传视频"')
                || emptyValidate(info.img1, '请上传"往期精彩回顾-精彩照片-图片1"')
                || emptyValidate(info.img2, '请上传"往期精彩回顾-精彩照片-图片2"')
                || emptyValidate(info.img3, '请上传"往期精彩回顾-精彩照片-图片3"')
                || emptyValidate(info.img4, '请上传"往期精彩回顾-精彩照片-图片4"')
                || emptyValidate(info.img5, '请上传"往期精彩回顾-精彩照片-图片5"')
                || emptyValidate(info.img6, '请上传"往期精彩回顾-精彩照片-图片6"')
                || emptyValidate(info.img7, '请上传"往期精彩回顾-精彩照片-图片7"')
        }

          validateResult = validateResult || emptyValidate(info.contactUsPc, '请填写"在线咨询及报名地址-联系方式(PC端)"')
            || emptyValidate(info.contactUsWap, '请填写"在线咨询及报名地址-拨号号码(WAP端)"')
            || emptyValidate(info.partLink, '请填写"在线咨询及报名地址-报名链接"')

        if (validateResult) {
            return;
        }

        JobFairApi.updateJobFair(info).then(resp=>{
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                navigate(-1)
            }
        })
    })

    return <div className="mgv12" style={{minWidth:800, maxWidth: 1200}}>
        <Topic info={info} onUpdate={onInfoUpdate} />
        <Changci info={info} labelList={labelList} onUpdate={onLabelListUpdate} />
        <Liucheng info={info} onUpdate={onInfoUpdate} />
        <Feiyong info={info} onUpdate={onInfoUpdate} />
        <Wangqihuigu info={info} onUpdate={onInfoUpdate} />
        <Zixunbaomin info={info} onUpdate={onInfoUpdate}/>

        <div className="text-right mgt30">
            <Space>
                <Button type="primary" onClick={save}>保存</Button>
            </Space>
        </div>
    </div>
}


function Title({title='', children}) {
    return <div className="flexbox pdv20 pdh32 border-bottom fts-18 bold">
        <span className="flex1">{title}</span>
        {children}
    </div>
}


function Topic({onUpdate, info = {}}) {
    const [bannerPc, setBannerPc] = useState(info.bannerPc)
    const [bannerWap, setBannerWap] = useState(info.bannerWap)

    useEffect(()=>{
        setBannerPc(info.bannerPc)
        setBannerWap(info.bannerWap)
    },[info])

    const onBannerPc = useCallback((url)=>{
        setBannerPc(url)
        onUpdate({bannerPc:url})
    })
    const onBannerWap = useCallback((url)=>{
        setBannerWap(url)
        onUpdate({bannerWap:url})
    })


    return (
    <div className="white-bg" style={{minWidth: 800, maxWidth: 1200}}>
        <Title title="宣传页主题"/>
        <div className="pdh32 pdv30">
            <div>
                <div className="bold">主题</div>
                <div className="flexbox mgb20 pdv12">
                    <div className="flex1 gray-dark pdh12 pdv8 border-radius white-light-bg">{info.name||'主题名称'}</div>
                    <div className="flex1" />
                </div>
            </div>
            <div className="flexbox">
                <div style={{width: '240px'}} >
                    <div className="gray-dark">banner（PC端）</div>
                    <div className="pdv12">
                        <PicUploader type={4} onResult={onBannerPc}>
                            {bannerPc && <Image src={bannerPc} preview={false} style={{width: 102, height: 102}}/>}
                            {!bannerPc && <div className="gray text-center">
                                <div className="fts-32 gray-light">+</div>
                                <div className="gray-light fts-13">建议尺寸1920*460px</div>
                            </div>}
                        </PicUploader>
                    </div>
                </div>
                <div style={{width: '240px'}} className="mgl80">
                    <div className="gray-dark">banner（WAP端）</div>
                    <div className="pdv12">
                        <PicUploader type={4} onResult={onBannerWap}>
                            {bannerWap && <Image src={bannerWap} preview={false} style={{width: 102, height: 102}}/>}
                            {!bannerWap && <div className="gray text-center">
                                <div className="fts-32 gray-light">+</div>
                                <div className="gray-light fts-13">建议尺寸750*360px</div>
                            </div>}
                        </PicUploader>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}



function Changci({onUpdate, info = {}, labelList=[]}) {
    const [lineList, setLineList] = useState(labelList,'sort')
    const [isLineShow, setIsLineShow] = useState(false)
    const [lineData, setLineData] = useState({})

    useEffect(()=>{
        setLineList(labelList,'sort')
    },[labelList])
    const showLineModal = useCallback((target)=>{
        if (target) {
            setLineData(target)
        } else {
            setLineData({
                jobFairId: info.id
            })
        }
        setIsLineShow(true)
    })
    const onLineClose = useCallback((data)=>{
        if (data) {
            if (lineData.id) {
                let lIndex = lineList.findIndex((item)=>item.id === lineData.id)
                Object.assign(lineList[lIndex], data)
                onUpdate(lineList)
                setLineList([...lineList])
            } else {
                onUpdate(lineList.concat([data]))
                setLineList([...lineList, data])
            }
        }
        setIsLineShow(false)
    })
    const toggleLayout = useCallback((lineItem)=>{
        JobFairApi.addJobFairLine({
            id:lineItem.id,
            jobFairId: lineItem.jobFairId,
            name: lineItem.name,
            sort: lineItem.sort,
            remarkPc: lineItem.remarkPc,
            remarkWap: lineItem.remarkWap,
            layout: lineItem.layout===1?2:1
        }).then(resp=>{
            if (resp.resultCode === 1) {
                let lIndex = lineList.findIndex((item) => item.id === lineItem.id)
                lineList[lIndex].layout = lineItem.layout === 1 ? 2 : 1
                setLineList([...lineList])
                onUpdate(lineList)
            }
        })
    })

    const deleteLine = useCallback((lineItem)=>{
        Modal.confirm({
            title: '确认删除？',
            content: lineItem.name,
            okText: '是',
            type: 'danger',
            cancelText: '否',
            onOk() {
                JobFairApi.deleteJobFairLine(lineItem.id, lineItem.jobFairId).then(resp=>{
                        if (resp.resultCode === 1) {
                            message.success(resp.resultMessage)
                            let lIndex = lineList.findIndex((item) => item.id === lineItem.id)
                            lineList.splice(lIndex, 1)
                            setLineList([...lineList])
                            onUpdate(lineList)
                        }
                })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    })

    const [isSchoolShow, setIsSchoolShow] = useState(false)
    const [schoolData, setSchoolData] = useState({})
    const showSchoolModal = useCallback((lineItemId, target)=>{
        if (target) {
            setSchoolData(target)
        } else {
            setSchoolData({
                jobFairId: info.id,
                jobFairLabelId: lineItemId
            })
        }
        setIsSchoolShow(true)
    })
    const onSchoolClose = useCallback((data)=>{
        if (data) {
            if (schoolData.id) {
                let lIndex = lineList.findIndex((item)=>item.id === data.jobFairLabelId)
                let sIndex = lineList[lIndex].schoolList.findIndex((item)=>item.id === schoolData.id)
                Object.assign(lineList[lIndex].schoolList[sIndex], data)

                onUpdate(lineList)
                setLineList([...lineList])
            } else {
                let lIndex = lineList.findIndex((item)=>item.id === data.jobFairLabelId)
                if (!lineList[lIndex].schoolList) lineList[lIndex].schoolList = []
                lineList[lIndex].schoolList.push(data)
                setLineList([...lineList])
                onUpdate(lineList)
            }
        }
        setIsSchoolShow(false)
    })

    const deleteSchool = useCallback((schoolItem)=>{
        Modal.confirm({
            title: '确认删除？',
            content: schoolItem.schoolName,
            okText: '是',
            type: 'danger',
            cancelText: '否',
            onOk() {
                JobFairApi.deleteJobFairSchool({
                    id:schoolItem.id,
                    jobFairId:schoolItem.jobFairId,
                    jobFairLabelId:schoolItem.jobFairLabelId
                }).then(resp=>{
                        if (resp.resultCode === 1) {
                            message.success(resp.resultMessage)
                            let lIndex = lineList.findIndex((item) => item.id === schoolItem.jobFairLabelId)
                            let sIndex = lineList[lIndex].schoolList.findIndex((item) => item.id === schoolItem.id)
                            lineList[lIndex].schoolList.splice(sIndex, 1)
                            setLineList([...lineList])
                            onUpdate(lineList)
                        }
                })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    })

    const updateSchoolSort = useCallback((schoolItem, sort)=>{
        if (schoolItem.sort != sort) {
            JobFairApi.updateJobFairSchoolSort({id:schoolItem.id,sort}).then(resp=>{
                if (resp.resultCode === 1) {
                    message.success(resp.resultMessage)
                    let lIndex = lineList.findIndex((item) => item.id === schoolItem.jobFairLabelId)
                    let sIndex = lineList[lIndex].schoolList.findIndex((item) => item.id === schoolItem.id)
                    lineList[lIndex].schoolList[sIndex].sort = sort
                    onUpdate(lineList)
                    setLineList([...lineList])
                }
            })
        }
    })


    return (
    <div className="white-bg mgt20" style={{minWidth: 800, maxWidth: 1200}}>
        <Title title="招聘会场次安排">
            <Button className="blue-bg" type="primary" onClick={()=>showLineModal()}>添加路线</Button>
        </Title>
        <div className="pdh32 pdv30">
            {sortList(lineList,'sort').map(lineItem=>(<div className="mgb12" key={lineItem.id+lineItem.name}>
                <div className="flexbox border pdh12 pdv8" >
                    <div className="flex1 green bold">
                        <span>{lineItem.name}</span>
                    </div>
                    <div className="flexbox">
                        <Button type="line" className="green pdh12" onClick={()=>showLineModal(lineItem)}>修改路线</Button>
                        <Button type="line" className="green pdh12" onClick={()=>toggleLayout(lineItem)}>{lineItem.layout===1?"竖版排版":"横版排版"}</Button>
                        <Button type="line" className="green pdh12" onClick={()=>showSchoolModal(lineItem.id)}>新增大学</Button>
                        <Button type="line" className="red pdh12" onClick={()=>deleteLine(lineItem)}>删除</Button>
                    </div>
                </div>
                <div>
                    {lineItem.schoolList && sortList(lineItem.schoolList,'sort').map(schoolItem=>(<div
                        key={schoolItem.id+schoolItem.schoolName}
                        className="flexbox border pdh12 pdv8"
                        style={{marginTop:-1}}>
                        <div className="flex1 pdl12">
                            <Input
                                defaultValue={schoolItem.sort}
                                min={0}
                                max={99}
                                type="number"
                                onBlur={(e)=>updateSchoolSort(schoolItem, e.target.value)}
                                onPressEnter={(e)=>updateSchoolSort(schoolItem, e.target.value)}
                                className="fts-12"
                                style={{borderRadius:0, width:20,height:20, padding:0, textAlign:'center', verticalAlign:'bottom'}}  />
                            <span className="pdl4">{schoolItem.schoolName}</span>
                        </div>
                        <div className="flexbox " >
                            <Button type="line" className="green pdh12" onClick={()=>showSchoolModal(lineItem.id, schoolItem)}>编辑</Button>
                            <Button type="line" className="red pdh12" onClick={()=>deleteSchool(schoolItem)}>删除</Button>
                        </div>
                    </div>))}
                </div>
            </div>))}
        </div>
        <LineModal data={lineData} isShow={isLineShow} onClose={onLineClose} />
        <SchoolModal data={schoolData} isShow={isSchoolShow} onClose={onSchoolClose} />
    </div>)
}


function Liucheng({onUpdate, info = {}}) {
    const [processPc, setProcessPc] = useState(info.processPc)
    const [processWap, setProcessWap] = useState(info.processWap)
    useEffect(()=>{
        setProcessPc(info.processPc)
        setProcessWap(info.processWap)
    },[info])

    const onProcessPc = useCallback((url)=>{
        setProcessPc(url)
        onUpdate({processPc:url})

    })
    const onProcessWap = useCallback((url)=>{
        setProcessWap(url)
        onUpdate({processWap:url})
    })

    return (
    <div className="white-bg mgt20" style={{minWidth: 800, maxWidth: 1200}}>
        <Title title="招聘会流程"/>
        <div className="pdh32 pdv30">
            <div className="flexbox">
                <div style={{width: '240px'}} >
                    <div className="gray-dark">PC端</div>
                    <div className="pdv12">
                        <PicUploader type={4} onResult={onProcessPc}>
                            {processPc && <Image src={processPc} preview={false} style={{width: 102, height: 102}}/>}
                            {!processPc && <div className="gray text-center">
                                <div className="fts-32 gray-light">+</div>
                                <div className="gray-light fts-13">建议尺寸1200*380px</div>
                            </div>}
                        </PicUploader>
                    </div>
                </div>
                <div style={{width: '240px'}} className="pd12 mgl80">
                    <div className="gray-dark">WAP端</div>
                    <div className="pdv12">
                        <PicUploader type={4} onResult={onProcessWap}>
                            {processWap && <Image src={processWap} preview={false} style={{width: 102, height: 102}}/>}
                            {!processWap && <div className="gray text-center">
                                <div className="fts-32 gray-light">+</div>
                                <div className="gray-light fts-13">建议尺寸710*880px</div>
                            </div>}
                        </PicUploader>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}

function Feiyong({onUpdate, info = {}}) {
    const [chargePc, setChargePc] = useState(info.chargePc)
    const [chargeWap, setChargeWap] = useState(info.chargeWap)
    const [chargeShow, setChargeShow] = useState(info.chargeShow)

    useEffect(()=>{
        setChargePc(info.chargePc)
        setChargeWap(info.chargeWap)
        setChargeShow(info.chargeShow)
    },[info])

    const onChargePc = useCallback((url)=>{
        setChargePc(url)
        onUpdate({chargePc:url})
    })

    const onChargeWap = useCallback((url)=>{
        setChargeWap(url)
        onUpdate({chargeWap:url})
    })

    const onChargeShow = useCallback(({nativeEvent})=>{
        console.info(nativeEvent.target.checked)
        setChargeShow(nativeEvent.target.checked)
        onUpdate({chargeShow: nativeEvent.target.checked})
    })

    return (
    <div className="white-bg mgt20" style={{minWidth: 800, maxWidth: 1200}}>
        <Title title="参会报名费用">
            <Checkbox checked={chargeShow} onChange={onChargeShow} >
                <span>显示改模块</span>
            </Checkbox>
        </Title>
        <div className="pdh32 pdv30">
            <div className="flexbox">
                <div style={{width: '240px'}} >
                    <div className="gray-dark">PC端</div>
                    <div className="pdv12">
                        <PicUploader type={4} onResult={onChargePc}>
                            {chargePc && <Image src={chargePc} preview={false} style={{width: 102, height: 102}}/>}
                            {!chargePc && <div className="gray text-center">
                                <div className="fts-32 gray-light">+</div>
                                <div className="gray-light fts-13">建议尺寸1200*340px</div>
                            </div>}
                        </PicUploader>
                    </div>
                </div>
                <div style={{width: '240px'}} className="pd12 mgl80">
                    <div className="gray-dark">WAP端</div>
                    <div className="pdv12">
                        <PicUploader type={4} onResult={onChargeWap}>
                            {chargeWap && <Image src={chargeWap} preview={false} style={{width: 102, height: 102}}/>}
                            {!chargeWap && <div className="gray text-center">
                                <div className="fts-32 gray-light">+</div>
                                <div className="gray-light fts-13">建议尺寸710*418px</div>
                            </div>}
                        </PicUploader>
                    </div>
                </div>
            </div>
        </div>
    </div>)
}

function Wangqihuigu({onUpdate, info = {}}) {
    const [reviewShow, setReviewShow] = useState(info.reviewShow)

    const [video, setVideo] = useState(info.video)
    const [img1, setImg1] = useState(info.img1)
    const [img2, setImg2] = useState(info.img2)
    const [img3, setImg3] = useState(info.img3)
    const [img4, setImg4] = useState(info.img4)
    const [img5, setImg5] = useState(info.img5)
    const [img6, setImg6] = useState(info.img6)
    const [img7, setImg7] = useState(info.img7)

    useEffect(()=>{
        setReviewShow(info.reviewShow)
        setVideo(info.video)
        setImg1(info.img1)
        setImg2(info.img2)
        setImg3(info.img3)
        setImg4(info.img4)
        setImg5(info.img5)
        setImg6(info.img6)
        setImg7(info.img7)
    },[info])

    const onReviewShow= useCallback(({nativeEvent})=>{
        setReviewShow(nativeEvent.target.checked)
        onUpdate({reviewShow: nativeEvent.target.checked})
    })

    const onVideo = useCallback((url)=>{
        setVideo(url)
        onUpdate({video:url})
    })

    const onImg1 = useCallback((url)=>{
        setImg1(url)
        onUpdate({img1:url})
    })
    const onImg2 = useCallback((url)=>{
        setImg2(url)
        onUpdate({img2:url})
    })
    const onImg3 = useCallback((url)=>{
        setImg3(url)
        onUpdate({img3:url})
    })
    const onImg4 = useCallback((url)=>{
        setImg4(url)
        onUpdate({img4:url})
    })
    const onImg5 = useCallback((url)=>{
        setImg5(url)
        onUpdate({img5:url})
    })
    const onImg6 = useCallback((url)=>{
        setImg6(url)
        onUpdate({img6:url})
    })
    const onImg7 = useCallback((url)=>{
        setImg7(url)
        onUpdate({img7:url})
    })

    return (
        <div className="white-bg mgt20" style={{minWidth: 800, maxWidth: 1200}}>
            <Title title="往期精彩回顾">
                <Checkbox checked={reviewShow} onChange={onReviewShow}>
                    <span>显示改模块</span>
                </Checkbox>
            </Title>
            <div className="pdh32 pdv30">
                <div className="gray-dark">宣传视频</div>
                <div className="mgt12">
                   <FileUploader type='xiaozhao' onResult={onVideo}/>
                    {!!video && <span className="blue mgl40">招聘会宣传视频.mp4</span>}
                </div>
                <div className="gray-light fts-13 mgt6">支持mp4格式</div>

                <div className="gray-dark mgt32">精彩照片（多图可传7张，建议尺寸：700x388px）</div>
                <div className="flexbox mgt12" style={{paddingRight:'260px'}}>
                    <PicUploader type={4} onResult={onImg1}>
                        {img1 && <Image src={img1} preview={false}  style={{width: 102, height: 102}}/>}
                        {!img1 && <div className="gray-light text-center">图片1</div>}
                    </PicUploader>
                    <PicUploader type={4} onResult={onImg2}>
                        {img2 && <Image src={img2} preview={false} style={{width: 102, height: 102}}/>}
                        {!img2 && <div className="gray-light text-center">图片2</div>}
                    </PicUploader>
                    <PicUploader type={4} onResult={onImg3}>
                        {img3 && <Image src={img3} preview={false} style={{width: 102, height: 102}}/>}
                        {!img3 && <div className="gray-light text-center">图片3</div>}
                    </PicUploader>
                    <PicUploader type={4} onResult={onImg4}>
                        {img4 && <Image src={img4} preview={false} style={{width: 102, height: 102}}/>}
                        {!img4 && <div className="gray-light text-center">图片4</div>}
                    </PicUploader>
                    <PicUploader type={4} onResult={onImg5}>
                        {img5 && <Image src={img5} preview={false} style={{width: 102, height: 102}}/>}
                        {!img5 && <div className="gray-light text-center">图片5</div>}
                    </PicUploader>
                    <PicUploader type={4} onResult={onImg6}>
                        {img6 && <Image src={img6} preview={false} style={{width: 102, height: 102}}/>}
                        {!img6 && <div className="gray-light text-center">图片6</div>}
                    </PicUploader>
                    <PicUploader type={4} onResult={onImg7}>
                        {img7 && <Image src={img7} preview={false} style={{width: 102, height: 102}}/>}
                        {!img7 && <div className="gray-light text-center">图片7</div>}
                    </PicUploader>
                </div>
            </div>
        </div>)
}

function Zixunbaomin({onUpdate, info = {}}) {
    const [contactUsWap, setContactUsWap] = useState(info.contactUsWap)
    const [contactUsPc, setContactUsPc] = useState(info.contactUsPc)
    const [partLink, setPartLink] = useState(info.partLink)

    useEffect(()=>{
        setContactUsWap(info.contactUsWap)
        setContactUsPc(info.contactUsPc)
        setPartLink(info.partLink)
    },[info])

    const onContactUsPc = useCallback((url)=>{
        setContactUsPc(url)
        onUpdate({contactUsPc:url})
    })

    const onContactUsWap = useCallback((value)=>{
        setContactUsWap(value)
        onUpdate({contactUsWap:value})
    })

    const onPartLink = useCallback((value)=>{
        setPartLink(value)
        onUpdate({partLink:value})
    })

    return (
        <div className="white-bg mgt20" style={{minWidth: 800, maxWidth: 1200}}>
            <Title title="在线咨询及报名地址" />

            <div className="pdh32 pdv30">
                <div className="flexbox">
                    <div className="pdr40" style={{width: '360px'}}>
                        <div className="gray-dark mgb8">拨号号码（WAP端）</div>
                        <Input placeholder="请输入号码"
                               maxLength={80}
                               value={contactUsWap}
                               onChange={(e) => onContactUsWap(e.target.value)}/>
                    </div>
                    <div className="pdr40"  style={{width: '360px'}}>
                        <div className="gray-dark mgb8">报名链接</div>
                        <Input placeholder="请输入链接地址"
                               maxLength={80}
                               value={partLink}
                               onChange={(e) => onPartLink(e.target.value)}/>
                    </div>
                </div>
                <div className="gray-dark mgt32">联系方式（PC端）</div>
                <div className="pdv12">
                    <PicUploader type={4} onResult={onContactUsPc}>
                        {contactUsPc && <Image src={contactUsPc} preview={false} style={{width: 102, height: 102}}/>}
                        {!contactUsPc && <div className="gray text-center">
                            <div className="fts-32 gray-light">+</div>
                            <div className="gray-light fts-13">建议尺寸150*250px</div>
                        </div>}
                    </PicUploader>
                </div>
            </div>
        </div>)
}



function sortList(list, key) {
    return list.sort((item1,item2)=>{
        if(item2[key] > item1[key]) {
            return 1
        }
        if(item2[key] < item1[key]) {
            return -1
        }

        return 0
    })
}
